import { CommonReferenceResponse } from "@/types/common"
import { queApi, handleReferenceResponse } from "@core/api/core"
import { InsuranceCompanyOption } from "@/types/insuranceCompany"

export const getReferenceTaCompanies = async (): Promise<InsuranceCompanyOption[]> => {
  const requestUrl = `/reference/ta_company/`
  const response = await queApi.get<CommonReferenceResponse>(requestUrl)
  const { columns, results } = handleReferenceResponse(response)

  const companies = results
    .map(row => {
      const obj = Array.isArray(row)
        ? (Object.fromEntries(columns.map((col, i) => [col, row[i]])) as Record<string, string | number | null | undefined>)
        : ((row || {}) as Record<string, string | number | null | undefined>)

      const label = String(obj.taCompanyName || obj.ta_company_name || "").trim()
      const value = String(obj.taCompanyCode || obj.ta_company_code || "").trim()
      if (!label || !value) return null
      return { label, value }
    })
    .filter((item): item is InsuranceCompanyOption => item !== null)

  return companies
}
